import { useEffect, useRef } from 'react'
import HotelClientApi from '../api/HotelClientApi'
import { resolveConnectedPartnerId } from '../app/admin/modules/GestionTransferts/Reservations/transferBillingIds'

export const findClientPassager = (clients) =>
  (Array.isArray(clients) ? clients : []).find(
    (c) => c.client_passager === 1 || c.client_passager === true || c.client_passager === '1',
  )

export const buildPassagerBillingFields = (passager, partnerId) => ({
  client_type: 'b2c',
  billing_client_kind: 'physique',
  billing_client_id: passager?.id ?? null,
  billing_partner_id: partnerId,
  billing_nom: '',
  billing_prenom: '',
  billing_email: '',
  billing_telephone: '',
  client_name: '',
  client_email: '',
  client_phone: '',
})

export const loadPartnerPassagerBillingFields = async () => {
  const partnerId = resolveConnectedPartnerId()
  if (!partnerId) return null

  const clients = await HotelClientApi.getAllClientsForDropdown()
  const passager = findClientPassager(clients)
  return buildPassagerBillingFields(passager, partnerId)
}

/**
 * Loads client passager billing once per enable cycle.
 * Uses refs so unstable parent callbacks (e.g. inline setField) do not retrigger the fetch.
 */
export const usePartnerPassagerBilling = (enabled, onFields) => {
  const onFieldsRef = useRef(onFields)
  onFieldsRef.current = onFields
  const loadedRef = useRef(false)

  useEffect(() => {
    if (!enabled) {
      loadedRef.current = false
      return undefined
    }
    if (loadedRef.current) return undefined
    loadedRef.current = true

    let cancelled = false
    loadPartnerPassagerBillingFields()
      .then((fields) => {
        if (!cancelled && fields) onFieldsRef.current?.(fields)
      })
      .catch((err) => {
        console.error('Failed to load client passager billing', err)
        loadedRef.current = false
      })

    return () => {
      cancelled = true
    }
  }, [enabled])
}
